module.exports = __webpack_public_path__ + "static/legacy_honor_bg-efeafddd5b4848c21ba0ff7cfe11233e.jpg";